import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface AlertInterface {
  successMessage: string | null;
  errorMessage: string | null;
  warningMessage: string | null;
  infoMessage: string | null;
}
const initialState: AlertInterface = {
  successMessage: null,
  errorMessage: null,
  warningMessage: null,
  infoMessage: null,
};

export const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setSuccessMessage: (state, action: PayloadAction<string | null>) => {
      state.successMessage = action.payload;
    },
    setErrorMessage: (state, action: PayloadAction<string | null>) => {
      state.errorMessage = action.payload;
    },
    setWarningMessage: (state, action: PayloadAction<string | null>) => {
      state.warningMessage = action.payload;
    },
    setInfoMessage: (state, action: PayloadAction<string | null>) => {
      state.infoMessage = action.payload;
    },
  },
});

export const {
  setSuccessMessage,
  setErrorMessage,
  setWarningMessage,
  setInfoMessage,
} = alertSlice.actions;
export const alertReducer = alertSlice.reducer;
